import { render, staticRenderFns } from "./Form16ProcessHeader.vue?vue&type=template&id=1fbe9daa&scoped=true"
import script from "./Form16ProcessHeader.vue?vue&type=script&lang=ts"
export * from "./Form16ProcessHeader.vue?vue&type=script&lang=ts"
import style0 from "./Form16ProcessHeader.vue?vue&type=style&index=0&id=1fbe9daa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fbe9daa",
  null
  
)

export default component.exports